var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRightLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 8,
    fill: "#6A65FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0001 46.3996C39.953 46.3996 46.4001 39.9525 46.4001 31.9996C46.4001 24.0467 39.953 17.5996 32.0001 17.5996C24.0472 17.5996 17.6001 24.0467 17.6001 31.9996C17.6001 39.9525 24.0472 46.3996 32.0001 46.3996ZM38.6729 29.6724C39.3758 28.9695 39.3758 27.8298 38.6729 27.1268C37.9699 26.4239 36.8302 26.4239 36.1273 27.1268L30.2001 33.054L27.8729 30.7268C27.1699 30.0239 26.0302 30.0239 25.3273 30.7268C24.6244 31.4298 24.6244 32.5695 25.3273 33.2724L28.9273 36.8724C29.6302 37.5753 30.7699 37.5753 31.4729 36.8724L38.6729 29.6724Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRightLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rightLogo.23a85286c27cec15f0d89c94ff1548f4.svg";